import { normalizeBoolean } from '@change/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_STARFISH_MULTIPLE_QRCODE_FLYERS = createFcmConfig('starfish_multiple_qrcode_flyers', {
	normalizer: normalizeBoolean,
	defaultValue: false,
});
